// TEAMS Website - VenuesSection Component
// Prestigious venues showcase

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal, useScrollRevealStagger } from '../../hooks/useScrollReveal.js';
import { getFeaturedVenues } from '../../data/venues.js';
import { ANIMATION_TIMING } from '../../styles/animation.js';
import '../../styles/main.scss';
import SectionHeader from '../ui/SectionHeader.jsx';

const VenuesSection = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });
  const [containerRef, logoElements] = useScrollRevealStagger(12, { staggerDelay: ANIMATION_TIMING.STAGGER_DELAY });

  // Get featured venues
  const featuredVenues = getFeaturedVenues();

  return (
    <section className="venues-section" ref={ref}>
      <div className="venues-section__container">
        <div className={`venues-section__content ${isVisible ? 'venues-section__content--visible' : ''}`}>
          {/* Section Header */}
           <SectionHeader
            title={t('venues.title')}
            subtitle={t('venues.subtitle')}
            alignment="center"
            size="large"
          />

          {/* Venue Logos Grid */}
          <div 
            ref={containerRef}
            className="venues-section__logos"
          >
            {featuredVenues.map((venue, index) => (
              <div
                key={index}
                ref={logoElements[index]?.ref}
                className={`card venues-section__venue-logo ${
                  logoElements[index]?.isVisible ? 'venues-section__venue-logo--visible' : ''
                }`}
                title={`${venue.name} - ${venue.city}, ${venue.country}`}
              >
                <img 
                  src={venue.image} 
                  alt={`${venue.name} - ${venue.city}`}
                  className="venues-section__venue-image"
                />
                <div className="venues-section__venue-overlay">
                  <div className="venues-section__venue-name">
                    {venue.name}
                  </div>
                  <div className="venues-section__venue-location">
                    {venue.city}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenuesSection;
